// extracted by css-extract-rspack-plugin
export default {"confirm":"Confirm-module__confirm__WFrz8a9","copilotRun":"Confirm-module__copilotRun__p56VGq8"};